import { render, staticRenderFns } from "./book-details.vue?vue&type=template&id=f145f478&scoped=true"
import script from "./book-details.vue?vue&type=script&lang=js"
export * from "./book-details.vue?vue&type=script&lang=js"
import style0 from "./book-details.vue?vue&type=style&index=0&id=f145f478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f145f478",
  null
  
)

export default component.exports